import script from "./SettingsShiftContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsShiftContent.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsShiftContent.vue?vue&type=style&index=0&id=58c21279&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58c21279"]])

export default __exports__